import { Box, useMediaQuery } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { ui } from "../i18n";
import { LayoutState, LayoutTextMarginTopLarge, LayoutTextMarginTopSmall, MediaQueryLinebreak, MediaQueryMobile, MediaQueryShallow, ScrollToPosition } from "../Layout";
import { change } from "../state/Nav";
import { RootState } from "../store";
import { TextBody, TextBox, TextHeader } from "../Styles";
import { hideKrpano } from "../Util";

export default function Oeuvre() {
        // Init layout parameters
        const layoutState = new LayoutState();
        layoutState.isMobile = useMediaQuery(MediaQueryMobile);
        layoutState.isShallow = useMediaQuery(MediaQueryShallow);
        layoutState.linebreak = useMediaQuery(MediaQueryLinebreak);

        // Determine UI language
        const lang = useSelector((state: RootState) => state.language.value);

        // Set navigation to current component
        const dispatch = useDispatch();
        dispatch(change("art"));

        // Hide virtual tour
        hideKrpano();

        // Scroll to previous position
        ScrollToPosition("art");

        return (<Box sx={{ paddingBottom: layoutState.LayoutPaddingBottom(), paddingTop: layoutState.paddingTop() }} >
                <TextBox>
                        <TextHeader>
                                {ui[lang].Art.p1}
                        </TextHeader>
                        <TextBody marginTop={LayoutTextMarginTopSmall}>
                                {ui[lang].Art.b1}
                        </TextBody>
                        <TextHeader marginTop={LayoutTextMarginTopLarge}>
                                {ui[lang].Art.p2}
                        </TextHeader>
                        <TextBody marginTop={LayoutTextMarginTopSmall}>
                                {ui[lang].Art.b2}
                        </TextBody>
                        <TextHeader marginTop={LayoutTextMarginTopLarge}>
                                {ui[lang].Art.p3}
                        </TextHeader>
                        <TextBody marginTop={LayoutTextMarginTopSmall}>
                                {ui[lang].Art.b3}
                        </TextBody>
                        <TextHeader marginTop={LayoutTextMarginTopLarge}>
                                {ui[lang].Art.p4}
                        </TextHeader>
                        <TextBody marginTop={LayoutTextMarginTopSmall}>
                                {ui[lang].Art.b4}
                        </TextBody>
                        <TextHeader marginTop={LayoutTextMarginTopLarge}>
                                {ui[lang].Art.p5}
                        </TextHeader>
                        <TextBody marginTop={LayoutTextMarginTopSmall}>
                                {ui[lang].Art.b5}
                        </TextBody>
                        <TextHeader marginTop={LayoutTextMarginTopLarge}>
                                {ui[lang].Art.p6}
                        </TextHeader>
                        <TextBody marginTop={LayoutTextMarginTopSmall}>
                                {ui[lang].Art.b6}
                        </TextBody>
                </TextBox>
        </Box>
        );
}